

































import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldPastRelevantDates'

  vue:
    props: ['value', 'errors']

    data: ->
      dates: @value || []

    computed:
      canAddTimeWindow: ->
        @dates.length < 10

      dateTimePickerOptions: ->
        disabledDate: @shouldDisableDate

      pastRelevantDates: ->
        @dates.map(({ period: [starts_on, ends_on], ugc }) => ({ starts_on, ends_on, ugc }))

    methods:
      hiAddTimeWindowRow: ->
        @addTimeWindowRow()

      hiRemoveTimeWindowRow: (index) ->
        @removeTimeWindowRow index

      hiDateTimeChanged: ->
        @inputChanged()

      addTimeWindowRow: ->
        @dates = [...@dates, { period: [], ugc: true }]

      removeTimeWindowRow: (index) ->
        return if @dates.length is 1
        @dates.splice index, 1

      shouldDisableDate: (date) ->
        start = dayjs().subtract(3, 'year')
        end = dayjs()
        !dayjs(date).isBetween(start, end, 'day')

      inputChanged: ->
        @$emit 'input', @pastRelevantDates
        @$emit 'change', @pastRelevantDates

export default VueOptions.vue settings
